export default {"src":"/_next/static/media/base-10-blocks.28d6fe39.svg","height":116,"width":143,"blurWidth":0,"blurHeight":0};